import React from "react";
import {
  Certificacion,
  CourseCounter,
} from "../../../../components";

const normalizePercent = (value) => {
  const number = Number(value);

  if (Number.isNaN(number)) return 0;

  return Math.min(100, Math.max(0, number));
};

export function CourseProgress({ user, course, courseAdvance }) {
  const progress = normalizePercent(courseAdvance?.percentage_course);
  const qualification = normalizePercent(courseAdvance?.qualification_course);

  const examsComplete = Number(courseAdvance?.total_exams_complete || 0);
  const totalExams = Number(courseAdvance?.total_exams || 0);

  return (
    <section className="modern-course-progress-panel anim" style={{ "--delay": ".1s" }}>
      <div className="modern-progress-heading">
        <div>
          <span>TU PROGRESO</span>
          <h2>Avance del curso</h2>
        </div>

        <strong>{Math.round(progress)}%</strong>
      </div>

      <div className="modern-progress-main">
        <div
          className="modern-progress-ring"
          style={{ "--course-progress": `${progress * 3.6}deg` }}
        >
          <div className="modern-progress-ring-center">
            <strong>{Math.round(progress)}%</strong>
            <span>completado</span>
          </div>
        </div>

        <div className="modern-progress-details">
          <div className="modern-progress-bar-heading">
            <span>Progreso general</span>
            <strong>{Math.round(progress)}%</strong>
          </div>

          <div className="modern-progress-track">
            <div
              className="modern-progress-track-fill"
              style={{ width: `${progress}%` }}
            />
          </div>

          <p>
            Completa las clases, materiales y evaluaciones para avanzar en tu
            capacitación.
          </p>

          <div className="modern-progress-stats">
            <div className="modern-progress-stat">
              <span>Calificación</span>
              <strong>
                {qualification > 0 ? `${Math.round(qualification)}%` : "—"}
              </strong>
            </div>

            <div className="modern-progress-stat">
              <span>Evaluaciones</span>
              <strong>
                {totalExams > 0
                  ? `${examsComplete}/${totalExams}`
                  : "—"}
              </strong>
            </div>

            <div className="modern-progress-stat modern-progress-counter">
              <span>Actividad</span>
              <div>
                <CourseCounter courseId={course?.id || 0} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modern-certificate-zone">
        <Certificacion
          user={user}
          course={course}
          percAvan={courseAdvance?.percentage_course}
          percCal={courseAdvance?.qualification_course}
          attemps={courseAdvance?.attemps}
        />
      </div>
    </section>
  );
}
